import React from "react";
import Frequent from "../../reusable/Frequent";
import OneTime from "../../reusable/OneTime";

class Traveller extends React.Component {
  render() {
    return (
        <section className="section bg-light" id="price">
          <div className="row vertical-content">
            <div className="col-lg-10">
              <img
                  src="/images/01_purchase_option_1.png"
                  alt=""
                  className="img-fluid mx-auto d-block"
              />
            </div>
          </div>
          <div style={{ clear: "both", height: "40px" }} />
          <div className="row vertical-content">
            <div className="col-lg-10">
              <img
                  src="/images/02_purchase_option_2.png"
                  alt=""
                  className="img-fluid mx-auto d-block"
              />
            </div>
          </div>
          <div style={{ clear: "both", height: "40px" }} />
          <div className="row vertical-content">
              <div className="col-lg-10">
                  <img
                      src="/images/03_rental.png"
                      alt=""
                      className="img-fluid mx-auto d-block"
                  />
              </div>
          </div>
          <div style={{ clear: "both", height: "40px" }} />
          <div className="row vertical-content">
              <div className="col-lg-10">
                  <img
                      src="/images/04_tmo_simcard.png"
                      alt=""
                      className="img-fluid mx-auto d-block"
                  />
              </div>
          </div>
          {/*<div className="container">
          <div className="row mt-5">
            <div className="col-lg-6 x">
              <div className="price_box text-center mt-3 p-5">
                <div className="price_name">
                  <h1 className="getbluetitle">USA</h1>
                </div>
                <div style={{ clear: "both", height: "20px" }} />
                <div className="price_name">
                  <h1 className="getredtitle pricing">
                    Rental Hotspot + Data (As low as $3 / day)
                  </h1>
                </div>
                <div className="plan_price pb-3 mt-4 pt-2">
                  <strong className="getmiddle">
                    US Mobile Hotspot Rental - 7 day pass 1 GB / Day Limit
                  </strong>
                  <div style={{ clear: "both" }} />
                  <h1 className="text-custom mb-0 font-weight-normal">$19</h1>
                </div>
                <div className="plan_price pb-3 mt-4 pt-2">
                  <strong className="getmiddle">
                    US Mobile Hotspot Rental - 10 day pass 1 GB / Day Limit
                  </strong>
                  <div style={{ clear: "both" }} />
                  <h1 className="text-custom mb-0 font-weight-normal">$25</h1>
                </div>

                <div className="plan_price pb-3 mt-4 pt-2">
                  <strong className="getmiddle">
                    US Mobile Hotspot Rental - 20 day pass 1 GB / Day Limit
                  </strong>
                  <div style={{ clear: "both" }} />
                  <h1 className="text-custom mb-0 font-weight-normal">$48</h1>
                </div>

                <div className="plan_price pb-3 mt-4 pt-2">
                  <strong className="getmiddle">
                    US Mobile Hotspot Rental - 30 day pass 1 GB / Day Limit
                  </strong>
                  <div style={{ clear: "both" }} />
                  <h1 className="text-custom mb-0 font-weight-normal">$68</h1>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="price_box text-center active mt-3 p-5">
                <div className="price_name">
                  <h1 className="getredtitle">Global</h1>
                </div>
                <div style={{ clear: "both", height: "20px" }} />
                <div className="price_name">
                  <h1 className="getredtitle pricing">
                    Rental Hotspot + Data (As low as $9 / day)
                  </h1>
                </div>

                 <div style={{ clear: "both", height: "20px" }} />

                <div className="plan_price pb-3 mt-4 pt-2">
                  <strong className="getmiddle">
                    Global Hotspot Rental - 7 days pass 0.5GB/Day LImit
                  </strong>
                  <div style={{ clear: "both" }} />
                  <h1 className="text-custom mb-0 font-weight-normal">$63</h1>
                </div>
                <div className="plan_price pb-3 mt-4 pt-2">
                  <strong className="getmiddle">
                    Global Hotspot Rental - 10 days pass 0.5GB/Day LImit{" "}
                  </strong>
                  <div style={{ clear: "both" }} />
                  <h1 className="text-custom mb-0 font-weight-normal">$85</h1>
                </div>
                <div className="plan_price pb-3 mt-4 pt-2">
                  <strong className="getmiddle">
                    Global Hotspot Rental - 20 days pass 0.5GB/Day LImit{" "}
                  </strong>
                  <div style={{ clear: "both" }} />
                  <h1 className="text-custom mb-0 font-weight-normal">$160</h1>
                </div>
                <div className="plan_price pb-3 mt-4 pt-2">
                  <strong className="getmiddle">
                    Global Hotspot Rental - 30 days pass 0.5GB/Day LImit{" "}
                  </strong>
                  <div style={{ clear: "both" }} />
                  <h1 className="text-custom mb-0 font-weight-normal">$225</h1>
                </div>
              </div>
            </div>
          </div>
        </div>*/}

        </section>
    );
  }
}

export default Traveller;



// WEBPACK FOOTER //
// ./src/pages/getwifius/Traveller.js